<template>
  <ReviewDisplay
    :id
    :average-rate
    :comment
    :country-code
    :customer
    :display-product-link
    :display-seller="true"
    :help-request
    :language-code
    :product
    :purchase-date="product.purchasedAt"
    :review-date="createdAt"
    :sales-order-item
    :seller
    :tags
    :track-review-impression="true"
    :trackingData="{
      onClick: clickTrackingData,
      onImpression: impressionTrackingData,
    }"
    :translated-comment
    :vote-count
  >
    <PhotosSlider
      data-test="photos-slider"
      v-bind="props"
      :trackingData="clickTrackingData"
    />
  </ReviewDisplay>
</template>

<script lang="ts" setup>
import { useRoute } from '#imports'

import ReviewDisplay from '@backmarket/nuxt-layer-reviews/review-display/ReviewDisplay.vue'

import { PRODUCT_ROUTES } from '~/scopes/product-core/route-names'

import type { DisplayedReview } from '../../models/reviews'
import PhotosSlider from '../PhotosSlider/PhotosSlider.vue'

const props = defineProps<
  DisplayedReview & {
    position: number
  }
>()

const route = useRoute()

const displayProductLink = route.name !== PRODUCT_ROUTES.VARIANT_PRODUCT_PAGE

const impressionTrackingData = {
  reviewPosition: props.position,
  pageType: route.name as string,
  reviewPhotos: Boolean(props.attachments?.length),
  photosReviewsDisplayed: (props.attachments || []).length,
  reviewComment: Boolean(props.comment),
  reviewVoteCount: props.voteCount,
  zone: 'reviews_list',
  reviewId: props.id,
}

const clickTrackingData = {
  zone: `review_position_${props.position}`,
  page_type: route.name as string,
  reviewId: props.id,
}
</script>
